<template>
	<modal ref="modal" size="modal-xl" style="z-index: 1999">
		<template #title>{{ subMenuParent }}</template>
		<template #body>
			<div v-if="submenus" class="table-responsive">
				<table class="table table-striped table-borderless table-hover table-vcenter">
					<thead>
						<tr>
							<th>MENU</th>
							<th>ICON</th>
							<th>URL</th>
							<th>RIBBON</th>
							<th>STATUS</th>
							<th>RANK VISIBILITY</th>
							<th>:::</th>
						</tr>
					</thead>
					<tbody class="fs-xs">
						<tr v-for="row in submenus" :key="row.counter">
							<td>{{ row.sidebar_submenu }}</td>
							<td>{{ row.icon }}</td>
							<td class="text-start text-info fw-semibold">
								<i>{{ row.url ?? '-' }}</i>
							</td>
							<td>
								<div v-html="row.ribbons"></div>
							</td>
							<td>
								<div class="form-check form-switch form-check-inline">
									<input
										class="form-check-input"
										type="checkbox"
										:checked="row.status"
										:value="row.status"
										:id="row.id"
										@change="handleStatus"
									/>
									<label class="form-check-label">
										<small>{{ row.status ? 'ON' : 'OFF' }}</small>
									</label>
								</div>
							</td>
							<td>
								<small>{{ row.rank_visibility }}</small>
							</td>
							<td class="space-x-1">
								<div class="btn-group">
									<inertia-link
										:href="
											route('admin.post.show-sidebar-details', {
												id: row.id,
												table: 'tbl_sidebar_submenu',
											})
										"
										method="post"
										as="button"
										class="btn btn-sm btn-alt-info js-bs-tooltip-enable me-1"
										data-bs-toggle="tooltip"
										data-bs-original-title="Edit"
										preserve-state
										preserve-scroll
									>
										<i class="fa fa-pencil-alt"></i>
									</inertia-link>
									<button
										type="button"
										class="btn btn-sm btn-alt-danger js-bs-tooltip-enable"
										data-bs-toggle="tooltip"
										data-bs-original-title="Delete"
									>
										<i class="fa fa-trash"></i>
									</button>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</template>
		<template #footer>
			<button @click="toggleModal" type="button" class="btn btn-alt-secondary">
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { ref } from 'vue'
import { Inertia } from '@inertiajs/inertia'

export default {
	props: {
		submenus: Object,
		subMenuParent: String,
	},
	setup() {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}

		const handleStatus = (e) => {
			Inertia.post(
				route('admin.post.update-menu-status'),
				{
					id: e.target.id,
					status: e.target.value,
					table: 'tbl_sidebar_submenu',
				},
				{
					preserveState: true,
					preserveScroll: true,
					only: ['flash'],
				}
			)
		}

		return {
			modal,
			toggleModal,
			handleStatus,
		}
	},
}
</script>
